import { Injectable } from '@angular/core';

import { UserService } from './user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalControlService {
  private modalRef?: BsModalRef;
  private modalClosed$ = new Subject<void>(); // <-- event emitter

  constructor(private modalService: BsModalService) {}

  openStepperModal(component: any) {
    this.modalRef = this.modalService.show(component, {
      class: 'modal-lg modal-dialog-centered custom-blur-modal',
      backdrop: 'static',
      keyboard: false,
    });

    // when modal is closed, emit event
    this.modalService.onHidden.subscribe(() => {
      this.modalClosed$.next();
    });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = undefined;
    }
  }

  // Observable to listen to modal close
  get modalClosed() {
    return this.modalClosed$.asObservable();
  }
}